import { render, staticRenderFns } from "./MultiSelectConfig.vue?vue&type=template&id=9868b85a&scoped=true"
import script from "./MultiSelectConfig.vue?vue&type=script&lang=js"
export * from "./MultiSelectConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9868b85a",
  null
  
)

export default component.exports